<template>
  <div class="el-core__header__right" data-onboarding="welcome">
    <div class="emd-drawer _right">
      <div class="emd-drawer__trigger" :class="{'_open': isOpenned}" @click="toggleMobileMenu">
        <div class="emd-action-button eu-ml_1">
          <i class="emd-action-button__icon uil uil-ellipsis-v"></i>
        </div>
      </div>
      <div class="emd-drawer__content" :class="{'_open': isOpenned}">
        <emd-application />
        <span>
          <emd-tippy :href="urlCompany" id="company" target="_blank" rel="noopener noreferrer" tag="a" class="emd-action-button _has-tooltip"  :type="'action-button'" :content="$t('company')">
            <i class="emd-action-button__icon uil uil-building"></i>
          </emd-tippy>
        </span>
        <emd-user-menu />
        <span v-if="isEmployee">
          <emd-tippy :href="urlBackoffice" target="_blank" rel="noopener noreferrer"  id="backoffice" tag="a" :class="['emd-action-button _type_outline _has-tooltip', backofficeIconClass]" :type="'action-button'" :content="$t('backoffice')">
            <span>
              <emd-pagarme-icon />
            </span>
          </emd-tippy>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import EmdTippy from '@/components/emerald/atoms/EmdTippy'
import EmdUserMenu from '@/components/emerald/molecules/EmdUserMenu'
import EmdApplication from '@/components/emerald/molecules/EmdApplication'
import EmdPagarmeIcon from '@/components/emerald/atoms/EmdPagarmeIcon.vue'

export default {
  name: 'AppCoreHeaderRight',
  components: {
    EmdTippy,
    EmdUserMenu,
    EmdApplication,
    EmdPagarmeIcon
  },
  computed: {
    isEmployee () {
      return this.$store.getters.isEmployee
    },
    urlCompany () {
      return `${process.env.VUE_APP_COMPANY_URL}/${this.$route.params.merchant_id}`
    },
    urlBackoffice () {
      return process.env.VUE_APP_BACKOFFICE_URL
    },
    backofficeIconClass () {
      return this.componentIsEnabled('backofficeIcon', 'pagarmeIcon') ? 'emd-pagarme-icon-outline' : 'emd-mundi-icon'
    }
  },
  data () {
    return {
      isOpenned: false
    }
  },
  methods: {
    toggleMobileMenu () {
      this.isOpenned = !this.isOpenned
    },
    componentIsEnabled (section, component) {
      return this.$store.getters.componentIsEnabled(section, component)
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "company": "Company",
    "backoffice": "Backoffice"
  },
  "en-US": {
    "company": "Company",
    "backoffice": "Backoffice"
  }
}
</i18n>
